var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap save_history"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_vm._m(0), _c('a', [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1)])])]), _c('div', {
    staticClass: "popup_content2"
  }, [_c('div', {
    staticClass: "popup_content_fix_top"
  }, [_c('ul', {
    staticClass: "fix_info_list"
  }, [_c('li', [_c('b', [_vm._v("노드타입")]), _c('span', [_vm._v(_vm._s(_vm.tagType == 'PROCESS' ? '공정' : _vm.tagType == 'MATERIAL' ? '재료' : '측정/분석'))])]), _c('li', [_c('b', [_vm._v("노드명")]), _c('span', [_vm._v(_vm._s(_vm.nodeName))])]), _c('li', [_c('b', [_vm._v("속성명")]), _c('span', [_vm._v(_vm._s(_vm.colName))])]), _c('li', [_c('b', [_vm._v("기본값SET")]), _c('span', [_vm._v(_vm._s(_vm.experimentName))])])])]), _c('div', {
    staticClass: "popup_content_fix_bottom"
  }, [_c('ul', {
    staticClass: "protocol_search_list"
  }, _vm._l(_vm.historyList, function (history, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "protocol_search_item"
    }, [_c('div', {
      staticClass: "top_info"
    }, [_c('div', {
      staticClass: "txt_cont"
    }, [_c('div', {
      staticClass: "tit_label",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [index == 0 ? _c('span', {
      staticClass: "label_color color_02"
    }, [_vm._v("생성")]) : _c('span', {
      staticClass: "label_color color_03"
    }, [_vm._v("변경")])]), _c('table', {
      staticClass: "change_info_cell"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("변경이전 "), _c('p', {
      staticClass: "writer_bubble_before"
    }, [_vm._v("작성자: " + _vm._s(history.oldUser))])]), _c('th', [_vm._v("변경이후 "), _c('p', {
      staticClass: "writer_bubble_after"
    }, [_vm._v("작성자: " + _vm._s(history.newUser))])])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(history.oldValue))]), _c('td', [_vm._v(_vm._s(history.newValue))])])])])])]), _c('div', {
      staticClass: "bottom_info"
    }, [_c('ul', {
      staticClass: "user_set"
    }, [_c('li', [_vm._v("변경일자 : " + _vm._s(history.changeDate))])]), _c('ul', {
      staticClass: "btn_set"
    }, [_c('li', {
      staticClass: "process"
    }, [_vm.revertAvailable ? _c('a', {
      staticClass: "process_chart_btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.revert(history.oldValue);
        }
      }
    }, [_vm._v(" 변경이전값으로 되돌리기 ")]) : _vm._e()])])])])]);
  }), 0)])]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v("CELL 변경이력")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

}]

export { render, staticRenderFns }